export default __webpack_public_path__ + "static/media/sands-of-time-desktop.e88d1590.mp4";